import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62046b43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "작성하기", -1))
const _hoisted_6 = { class: "wrapper_container" }
const _hoisted_7 = { class: "write_box" }
const _hoisted_8 = { class: "write_content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "gray regular" }, " 조합의 최신 정보, 궁금한 점, 투자 경험담, 주주로서의 생각 등을 자유롭게 남겨주세요! ")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "write_byte" }
const _hoisted_12 = { class: "black" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "/400", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, "취소")
        ])
      ])
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("label", {
                id: "board_content",
                for: "input_content",
                class: "board_content",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args)))
              }, _hoisted_10, 512), [
                [_vShow, !_ctx.focusToggle]
              ]),
              _withDirectives(_createElementVNode("textarea", {
                id: "input_content",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.boardData.contents) = $event)),
                class: "input_content",
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleContent && _ctx.handleContent(...args))),
                onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
              }, null, 544), [
                [_vShow, _ctx.focusToggle],
                [_vModelText, _ctx.boardData.contents]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.boardData.contents.length), 1),
              _hoisted_13
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, {
      "align-title": "left",
      "keyboard-attach": "",
      class: "bar-assertive"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "block_btn",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveBoard && _ctx.saveBoard(...args)))
        }, " 등록 ")
      ]),
      _: 1
    })
  ], 64))
}